import classNames from 'classnames';

/** Tiny className helper (re-export of `classnames`) used across the UI primitives. */
export const cn = classNames;
